export const API_URL = "https://dynaslope.com.ph:5001";
export const STORAGE_URL = "https://dynaslope.com.ph:8080";
export const SITE_CODE = "mar";
export const SITE_ID = 29;
